/**
 * Return a legacy local storage item which was set using one of the @dotdev utilities.
 *
 * These local storage items are stored using the "store" npm package, which is
 * ancient, and we want to avoid bringing directly into our project.
 *
 * This method carefully unpacks the local storage item with the given key.
 *
 * The value could be anything. Some keys are stored as string, some are objects etc.
 *
 * @deprecated Do not use this for anything new, only for fetching legacy local
 * storage items for the purpose of migration. Instead, you should use the
 * browser local storage API directly.
 */
export function getLegacyLocalStorageItem(key: string): null | unknown {
  try {
    // Get the raw local storage item.
    const item = localStorage.getItem(key)
    if (!item) return null

    // It is stored as JSON encoded string, which itself is a JSON encoded object.
    const jsonString = JSON.parse(item)
    if (!jsonString || "string" !== typeof jsonString) return null

    // The, we must decode the JSON encoded object.
    const json = JSON.parse(jsonString)
    if (!json || "object" !== typeof json) return null

    // Return the value.
    return (json as any).value as unknown
  } catch {
    return null
  }
}
